import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useState, useRef } from 'react';
import { useClickAway } from 'react-use';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var MobileIcon = function MobileIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.7587 2H14.2413C15.0463 1.99999 15.7106 1.99998 16.2518 2.04419C16.8139 2.09012 17.3306 2.18868 17.816 2.43597C18.5686 2.81947 19.1805 3.43139 19.564 4.18404C19.8113 4.66937 19.9099 5.18608 19.9558 5.74817C20 6.28936 20 6.95372 20 7.75868V16.2413C20 17.0463 20 17.7106 19.9558 18.2518C19.9099 18.8139 19.8113 19.3306 19.564 19.816C19.1805 20.5686 18.5686 21.1805 17.816 21.564C17.3306 21.8113 16.8139 21.9099 16.2518 21.9558C15.7106 22 15.0463 22 14.2413 22H9.75868C8.95372 22 8.28936 22 7.74818 21.9558C7.18608 21.9099 6.66937 21.8113 6.18404 21.564C5.43139 21.1805 4.81947 20.5686 4.43597 19.816C4.18868 19.3306 4.09012 18.8139 4.04419 18.2518C3.99998 17.7106 3.99999 17.0463 4 16.2413V7.7587C3.99999 6.95373 3.99998 6.28937 4.04419 5.74817C4.09012 5.18608 4.18868 4.66937 4.43597 4.18404C4.81947 3.43139 5.43139 2.81947 6.18404 2.43597C6.66937 2.18868 7.18608 2.09012 7.74817 2.04419C8.28937 1.99998 8.95373 1.99999 9.7587 2ZM7.91104 4.03755C7.47262 4.07337 7.24842 4.1383 7.09202 4.21799C6.7157 4.40973 6.40973 4.7157 6.21799 5.09202C6.1383 5.24842 6.07337 5.47262 6.03755 5.91104C6.00078 6.36113 6 6.94342 6 7.8V16.2C6 17.0566 6.00078 17.6389 6.03755 18.089C6.07337 18.5274 6.1383 18.7516 6.21799 18.908C6.40973 19.2843 6.7157 19.5903 7.09202 19.782C7.24842 19.8617 7.47262 19.9266 7.91104 19.9624C8.36113 19.9992 8.94342 20 9.8 20H14.2C15.0566 20 15.6389 19.9992 16.089 19.9624C16.5274 19.9266 16.7516 19.8617 16.908 19.782C17.2843 19.5903 17.5903 19.2843 17.782 18.908C17.8617 18.7516 17.9266 18.5274 17.9625 18.089C17.9992 17.6389 18 17.0566 18 16.2V7.8C18 6.94342 17.9992 6.36113 17.9625 5.91104C17.9266 5.47262 17.8617 5.24842 17.782 5.09202C17.5903 4.7157 17.2843 4.40973 16.908 4.21799C16.7516 4.1383 16.5274 4.07337 16.089 4.03755C15.6389 4.00078 15.0566 4 14.2 4H9.8C8.94342 4 8.36113 4.00078 7.91104 4.03755Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z",
      fill: "#12131A"
    })]
  }));
};

MobileIcon.defaultProps = {
  width: "20",
  height: "24",
  viewBox: "0 0 20 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var LaptopIcon = function LaptopIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.02393 6.96784C6.00078 7.25117 6 7.62345 6 8.2L6 14H18V8.2C18 7.62345 17.9992 7.25117 17.9761 6.96784C17.9539 6.69617 17.9162 6.59545 17.891 6.54601C17.7951 6.35785 17.6422 6.20487 17.454 6.10899C17.4045 6.0838 17.3038 6.04612 17.0322 6.02393C16.7488 6.00078 16.3766 6 15.8 6L8.2 6C7.62345 6 7.25117 6.00078 6.96784 6.02393C6.69617 6.04612 6.59546 6.0838 6.54601 6.10899C6.35785 6.20487 6.20487 6.35785 6.109 6.54601C6.0838 6.59545 6.04612 6.69617 6.02393 6.96784ZM4.03057 6.80497C4.06287 6.40963 4.13419 6.01641 4.32698 5.63803C4.6146 5.07354 5.07354 4.6146 5.63803 4.32698C6.01641 4.13419 6.40963 4.06287 6.80497 4.03057C7.17955 3.99997 7.63432 3.99998 8.16148 4L15.8385 4C16.3657 3.99998 16.8205 3.99997 17.195 4.03057C17.5904 4.06287 17.9836 4.13419 18.362 4.32698C18.9265 4.6146 19.3854 5.07354 19.673 5.63803C19.8658 6.01641 19.9371 6.40963 19.9694 6.80497C20 7.17955 20 7.63432 20 8.16148V16H4L4 8.16146C3.99998 7.63431 3.99997 7.17955 4.03057 6.80497Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.00302 16.0143C4.00004 16.0796 3.9998 16.1693 3.9998 16.3333C3.9998 17.0177 4.00839 17.1637 4.03387 17.2588C4.12634 17.6039 4.39589 17.8735 4.74098 17.9659C4.83609 17.9914 4.9821 18 5.66647 18L18.3331 18C19.0175 18 19.1635 17.9914 19.2586 17.9659C19.6037 17.8735 19.8733 17.6039 19.9657 17.2588C19.9912 17.1637 19.9998 17.0177 19.9998 16.3333C19.9998 16.1693 19.9996 16.0796 19.9966 16.0143C19.9964 16.0105 19.9962 16.007 19.9961 16.0038C19.9928 16.0036 19.9893 16.0034 19.9855 16.0032C19.9202 16.0003 19.8305 16 19.6665 16L4.33313 16C4.16907 16 4.07939 16.0003 4.01406 16.0032C4.01028 16.0034 4.00678 16.0036 4.00354 16.0038C4.00337 16.007 4.00319 16.0105 4.00302 16.0143ZM1.99966 16.2658C1.99895 16.031 1.99807 15.7432 2.06795 15.4824C2.25288 14.7922 2.79198 14.2531 3.48216 14.0682C3.74295 13.9983 4.03076 13.9992 4.26559 13.9999C4.28864 13.9999 4.31118 14 4.33313 14L19.6665 14C19.6884 14 19.711 13.9999 19.734 13.9999C19.9688 13.9992 20.2566 13.9983 20.5174 14.0682C21.2076 14.2531 21.7467 14.7922 21.9317 15.4824C22.0015 15.7432 22.0007 16.031 21.9999 16.2658C21.9999 16.2889 21.9998 16.3114 21.9998 16.3333C21.9998 16.371 21.9998 16.4083 21.9999 16.4452C22.0004 16.9529 22.0009 17.3909 21.8976 17.7765C21.6202 18.8117 20.8115 19.6204 19.7763 19.8978C19.3907 20.0011 18.9527 20.0006 18.445 20.0001C18.4081 20.0001 18.3708 20 18.3331 20L5.66647 20C5.62881 20 5.59153 20.0001 5.55462 20.0001C5.0469 20.0006 4.60887 20.0011 4.22334 19.8978C3.18807 19.6204 2.37942 18.8117 2.10202 17.7765C1.99872 17.3909 1.99918 16.9529 1.99972 16.4452C1.99976 16.4083 1.9998 16.371 1.9998 16.3333C1.9998 16.3114 1.99973 16.2889 1.99966 16.2658Z",
      fill: "#12131A"
    })]
  }));
};

LaptopIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var PaperIcon = function PaperIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_357_4954)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.8915 1.01264C24.7926 0.748813 23.6531 0.749356 22.1449 0.750073L14.1769 0.750149C12.2651 0.750118 10.6873 0.750093 9.40192 0.85511C8.06694 0.964182 6.83977 1.19827 5.68709 1.78559C3.89955 2.69638 2.44624 4.1497 1.53544 5.93724C0.948125 7.08991 0.714035 8.31708 0.604963 9.65206C0.499947 10.9374 0.499972 12.5152 0.500001 14.427V34.5732C0.499972 36.485 0.499947 38.0629 0.604963 39.3482C0.714035 40.6832 0.948125 41.9104 1.53544 43.0631C2.44624 44.8506 3.89955 46.3039 5.68709 47.2147C6.83977 47.802 8.06694 48.0361 9.40192 48.1452C10.6872 48.2502 12.2651 48.2502 14.1769 48.2501H24.8231C26.7349 48.2502 28.3128 48.2502 29.5981 48.1452C30.9331 48.0361 32.1602 47.802 33.3129 47.2147C35.1005 46.3039 36.5538 44.8506 37.4646 43.0631C38.0519 41.9104 38.286 40.6832 38.395 39.3482C38.5001 38.0629 38.5 36.485 38.5 34.5732L38.5001 17.1052C38.5008 15.5971 38.5013 14.4576 38.2375 13.3587C38.0048 12.3893 37.621 11.4627 37.1001 10.6127C36.5096 9.6491 35.7035 8.84373 34.6366 7.77784L31.4723 4.6136C30.4064 3.5467 29.6011 2.74056 28.6375 2.15007C27.7875 1.6292 26.8608 1.24535 25.8915 1.01264ZM21.875 5.50015H14.275C12.2406 5.50015 10.8577 5.502 9.78872 5.58933C8.74748 5.67441 8.215 5.82861 7.84355 6.01787C6.94978 6.47327 6.22312 7.19993 5.76772 8.0937C5.57846 8.46514 5.42426 8.99763 5.33919 10.0389C5.25185 11.1078 5.25 12.4908 5.25 14.5251V34.4751C5.25 36.5095 5.25185 37.8925 5.33919 38.9614C5.42426 40.0027 5.57846 40.5352 5.76772 40.9066C6.22312 41.8004 6.94978 42.527 7.84355 42.9824C8.215 43.1717 8.74748 43.3259 9.78872 43.411C10.8577 43.4983 12.2406 43.5001 14.275 43.5001H24.725C26.7594 43.5001 28.1423 43.4983 29.2113 43.411C30.2525 43.3259 30.785 43.1717 31.1565 42.9824C32.0502 42.527 32.7769 41.8004 33.2323 40.9066C33.4215 40.5352 33.5757 40.0027 33.6608 38.9614C33.7482 37.8925 33.75 36.5095 33.75 34.4751V17.3751H29C25.065 17.3751 21.875 14.1852 21.875 10.2501V5.50015ZM32.7049 12.6251C32.4195 12.2876 31.9637 11.8226 31.1066 10.9655L28.2846 8.14351C27.4275 7.28642 26.9625 6.83062 26.625 6.54521V10.2501C26.625 11.5618 27.6883 12.6251 29 12.6251H32.7049Z",
        fill: "#12131A"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_357_4954",
        children: /*#__PURE__*/_jsx("rect", {
          width: "39",
          height: "49",
          fill: "white"
        })
      })
    })]
  }));
};

PaperIcon.defaultProps = {
  width: "39",
  height: "49",
  viewBox: "0 0 39 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var FacebookLogo = function FacebookLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("style", {
      type: "text/css",
      children: [".st0", `{`, "fill:url(#SVGID_1_);", `}`, ".st1", `{`, "fill:#FFFFFF;", `}`]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "SVGID_1_",
      gradientUnits: "userSpaceOnUse",
      x1: "-277.375",
      y1: "406.6018",
      x2: "-277.375",
      y2: "407.5726",
      gradientTransform: "matrix(40 0 0 -39.7778 11115.001 16212.334)",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0",
        style: {
          stopColor: "#0062E0"
        }
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        style: {
          stopColor: "#19AFFF"
        }
      })]
    }), /*#__PURE__*/_jsx("path", {
      className: "st0",
      d: "M16.7,39.8C7.2,38.1,0,29.9,0,20C0,9,9,0,20,0s20,9,20,20c0,9.9-7.2,18.1-16.7,19.8l-1.1-0.9h-4.4L16.7,39.8z"
    }), /*#__PURE__*/_jsx("path", {
      className: "st1",
      d: "M27.8,25.6l0.9-5.6h-5.3v-3.9c0-1.6,0.6-2.8,3-2.8h2.6V8.2c-1.4-0.2-3-0.4-4.4-0.4c-4.6,0-7.8,2.8-7.8,7.8V20\r h-5v5.6h5v14.1c1.1,0.2,2.2,0.3,3.3,0.3c1.1,0,2.2-0.1,3.3-0.3V25.6H27.8z"
    })]
  }));
};

FacebookLogo.defaultProps = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 40 40",
  style: {
    enableBackground: "new 0 0 40 40"
  },
  xmlSpace: "preserve"
};

var InstagramLogo = function InstagramLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M66.0339 1C38.8919 1 30.9539 1.028 29.4109 1.156C23.8409 1.619 20.3749 2.496 16.5989 4.376C13.6889 5.821 11.3939 7.496 9.12893 9.844C5.00393 14.126 2.50393 19.394 1.59893 25.656C1.15893 28.696 1.03093 29.316 1.00493 44.844C0.994933 50.02 1.00493 56.832 1.00493 65.969C1.00493 93.089 1.03493 101.019 1.16493 102.559C1.61493 107.979 2.46493 111.389 4.26493 115.119C7.70493 122.259 14.2749 127.619 22.0149 129.619C24.6949 130.309 27.6549 130.689 31.4549 130.869C33.0649 130.939 49.4749 130.989 65.8949 130.989C82.3149 130.989 98.7349 130.969 100.305 130.889C104.705 130.682 107.26 130.339 110.085 129.609C117.875 127.599 124.325 122.319 127.835 115.079C129.6 111.439 130.495 107.899 130.9 102.762C130.988 101.642 131.025 83.785 131.025 65.952C131.025 48.116 130.985 30.292 130.897 29.172C130.487 23.952 129.592 20.442 127.77 16.732C126.275 13.695 124.615 11.427 122.205 9.108C117.904 5 112.644 2.5 106.376 1.596C103.339 1.157 102.734 1.027 87.1939 1H66.0339Z",
      fill: "url(#paint0_radial_357_4912)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M66.0339 1C38.8919 1 30.9539 1.028 29.4109 1.156C23.8409 1.619 20.3749 2.496 16.5989 4.376C13.6889 5.821 11.3939 7.496 9.12893 9.844C5.00393 14.126 2.50393 19.394 1.59893 25.656C1.15893 28.696 1.03093 29.316 1.00493 44.844C0.994933 50.02 1.00493 56.832 1.00493 65.969C1.00493 93.089 1.03493 101.019 1.16493 102.559C1.61493 107.979 2.46493 111.389 4.26493 115.119C7.70493 122.259 14.2749 127.619 22.0149 129.619C24.6949 130.309 27.6549 130.689 31.4549 130.869C33.0649 130.939 49.4749 130.989 65.8949 130.989C82.3149 130.989 98.7349 130.969 100.305 130.889C104.705 130.682 107.26 130.339 110.085 129.609C117.875 127.599 124.325 122.319 127.835 115.079C129.6 111.439 130.495 107.899 130.9 102.762C130.988 101.642 131.025 83.785 131.025 65.952C131.025 48.116 130.985 30.292 130.897 29.172C130.487 23.952 129.592 20.442 127.77 16.732C126.275 13.695 124.615 11.427 122.205 9.108C117.904 5 112.644 2.5 106.376 1.596C103.339 1.157 102.734 1.027 87.1939 1H66.0339Z",
      fill: "url(#paint1_radial_357_4912)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M66.004 18C52.968 18 51.332 18.057 46.212 18.29C41.102 18.524 37.614 19.333 34.562 20.52C31.405 21.746 28.727 23.386 26.059 26.055C23.389 28.723 21.749 31.401 20.519 34.557C19.329 37.61 18.519 41.099 18.289 46.207C18.06 51.327 18 52.964 18 66C18 79.036 18.058 80.667 18.29 85.787C18.525 90.897 19.334 94.385 20.52 97.437C21.747 100.594 23.387 103.272 26.056 105.94C28.723 108.61 31.401 110.254 34.556 111.48C37.61 112.667 41.099 113.476 46.208 113.71C51.328 113.943 52.963 114 65.998 114C79.035 114 80.666 113.943 85.786 113.71C90.896 113.476 94.388 112.667 97.442 111.48C100.598 110.254 103.272 108.61 105.939 105.94C108.609 103.272 110.249 100.594 111.479 97.438C112.659 94.385 113.469 90.896 113.709 85.788C113.939 80.668 113.999 79.036 113.999 66C113.999 52.964 113.939 51.328 113.709 46.208C113.469 41.098 112.659 37.61 111.479 34.558C110.249 31.401 108.609 28.723 105.939 26.055C103.269 23.385 100.599 21.745 97.439 20.52C94.379 19.333 90.889 18.524 85.779 18.29C80.659 18.057 79.029 18 65.989 18H66.004ZM61.698 26.65C62.976 26.648 64.402 26.65 66.004 26.65C78.82 26.65 80.339 26.696 85.4 26.926C90.08 27.14 92.62 27.922 94.312 28.579C96.552 29.449 98.149 30.489 99.828 32.169C101.508 33.849 102.548 35.449 103.42 37.689C104.077 39.379 104.86 41.919 105.073 46.599C105.303 51.659 105.353 53.179 105.353 65.989C105.353 78.799 105.303 80.319 105.073 85.379C104.859 90.059 104.077 92.599 103.42 94.289C102.55 96.529 101.508 98.124 99.828 99.803C98.148 101.483 96.553 102.523 94.312 103.393C92.622 104.053 90.08 104.833 85.4 105.047C80.34 105.277 78.82 105.327 66.004 105.327C53.187 105.327 51.668 105.277 46.608 105.047C41.928 104.831 39.388 104.049 37.695 103.392C35.455 102.522 33.855 101.482 32.175 99.802C30.495 98.122 29.455 96.526 28.583 94.285C27.926 92.595 27.143 90.055 26.93 85.375C26.7 80.315 26.654 78.795 26.654 65.977C26.654 53.159 26.7 51.647 26.93 46.587C27.144 41.907 27.926 39.367 28.583 37.675C29.453 35.435 30.495 33.835 32.175 32.155C33.855 30.475 35.455 29.435 37.695 28.563C39.387 27.903 41.928 27.123 46.608 26.908C51.036 26.708 52.752 26.648 61.698 26.638V26.65ZM91.626 34.62C88.446 34.62 85.866 37.197 85.866 40.378C85.866 43.558 88.446 46.138 91.626 46.138C94.806 46.138 97.386 43.558 97.386 40.378C97.386 37.198 94.806 34.618 91.626 34.618V34.62ZM66.004 41.35C52.391 41.35 41.354 52.387 41.354 66C41.354 79.613 52.391 90.645 66.004 90.645C79.617 90.645 90.65 79.613 90.65 66C90.65 52.387 79.617 41.35 66.004 41.35ZM66.004 50C74.84 50 82.004 57.163 82.004 66C82.004 74.836 74.84 82 66.004 82C57.167 82 50.004 74.836 50.004 66C50.004 57.163 57.167 50 66.004 50Z",
      fill: "white"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("radialGradient", {
        id: "paint0_radial_357_4912",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(35.5384 141.001) rotate(-90) scale(128.829 119.853)",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FFDD55"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.1",
          stopColor: "#FFDD55"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.5",
          stopColor: "#FF543E"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#C837AB"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        id: "paint1_radial_357_4912",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-20.7793 10.3642) rotate(78.6776) scale(57.5876 237.438)",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#3771C8"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.128",
          stopColor: "#3771C8"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#6600FF",
          stopOpacity: "0"
        })]
      })]
    })]
  }));
};

InstagramLogo.defaultProps = {
  width: "133",
  height: "132",
  viewBox: "0 0 133 132",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var LinkedinLogo = function LinkedinLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M0.883301 6.24536C0.883301 3.22963 3.39001 0.783429 6.48236 0.783429H71.0515C74.1438 0.783429 76.6506 3.22963 76.6506 6.24536V71.5695C76.6506 74.5862 74.1438 77.0314 71.0515 77.0314H6.48236C3.39001 77.0314 0.883301 74.5862 0.883301 71.5695V6.24536Z",
      fill: "#006699"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.8507 64.6109V30.1807H12.4067V64.6109H23.8507ZM18.1287 25.4798C22.1194 25.4798 24.6033 22.8359 24.6033 19.5319C24.5289 16.1535 22.1194 13.583 18.2044 13.583C14.2897 13.583 11.7302 16.1535 11.7302 19.5319C11.7302 22.8359 14.2136 25.4798 18.0541 25.4798H18.1287Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M30.1831 64.6109H41.627V45.3836C41.627 44.3546 41.7013 43.3266 42.0035 42.591C42.8308 40.535 44.7138 38.4057 47.8752 38.4057C52.0163 38.4057 53.6728 41.563 53.6728 46.1915V64.6109H65.1157V44.8691C65.1157 34.2937 59.4699 29.3727 51.9407 29.3727C45.767 29.3727 43.0567 32.8235 41.5509 35.1739H41.6273V30.1807H30.1834C30.3336 33.4114 30.1831 64.6109 30.1831 64.6109Z",
      fill: "white"
    })]
  }));
};

LinkedinLogo.defaultProps = {
  width: "77",
  height: "78",
  viewBox: "0 0 77 78",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ProductHuntLogo = function ProductHuntLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M58.48 29.24C58.48 45.388 45.388 58.48 29.24 58.48C13.09 58.48 0 45.388 0 29.24C0 13.09 13.091 0 29.24 0C45.388 0 58.48 13.091 58.48 29.24Z",
      fill: "#DA552F"
    }), /*#__PURE__*/_jsx("path", {
      d: "M33.1381 29.24H24.8541V20.468H33.1381C33.7141 20.468 34.2844 20.5814 34.8166 20.8019C35.3487 21.0223 35.8322 21.3453 36.2395 21.7526C36.6468 22.1599 36.9698 22.6434 37.1902 23.1755C37.4107 23.7077 37.5241 24.278 37.5241 24.854C37.5241 25.43 37.4107 26.0003 37.1902 26.5324C36.9698 27.0646 36.6468 27.5481 36.2395 27.9554C35.8322 28.3626 35.3487 28.6857 34.8166 28.9061C34.2844 29.1265 33.7141 29.24 33.1381 29.24ZM33.1381 14.62H19.0061V43.86H24.8541V35.088H33.1381C38.7901 35.088 43.3721 30.506 43.3721 24.854C43.3721 19.202 38.7901 14.62 33.1381 14.62Z",
      fill: "white"
    })]
  }));
};

ProductHuntLogo.defaultProps = {
  width: "59",
  height: "59",
  viewBox: "0 0 59 59",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var PinterestLogo = function PinterestLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_357_4921)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M305.293 153.25C305.293 237.468 237.02 305.74 152.803 305.74C68.5855 305.74 0.312988 237.468 0.312988 153.25C0.312988 69.0314 68.5855 0.76012 152.803 0.76012C237.02 0.76012 305.293 69.0314 305.293 153.25Z",
        fill: "white"
      }), /*#__PURE__*/_jsx("path", {
        d: "M152.803 0.759876C68.5852 0.759876 0.312744 69.0324 0.312744 153.25C0.312744 217.852 40.5065 273.079 97.2315 295.297C95.899 283.232 94.694 264.677 97.7602 251.506C100.531 239.605 115.641 175.709 115.641 175.709C115.641 175.709 111.08 166.574 111.08 153.069C111.08 131.865 123.37 116.035 138.673 116.035C151.683 116.035 157.966 125.802 157.966 137.515C157.966 150.599 149.636 170.16 145.338 188.287C141.745 203.465 152.949 215.842 167.919 215.842C195.021 215.842 215.855 187.265 215.855 146.014C215.855 109.502 189.62 83.9749 152.159 83.9749C108.77 83.9749 83.3027 116.519 83.3027 150.151C83.3027 163.257 88.3515 177.311 94.6515 184.951C95.8977 186.461 96.0802 187.784 95.709 189.325C94.5515 194.141 91.979 204.499 91.474 206.619C90.809 209.41 89.264 210.002 86.374 208.657C67.329 199.792 55.4215 171.947 55.4215 149.582C55.4215 101.48 90.3715 57.3036 156.178 57.3036C209.076 57.3036 250.185 94.9986 250.185 145.375C250.185 197.929 217.049 240.224 171.056 240.224C155.604 240.224 141.078 232.196 136.105 222.714C136.105 222.714 128.459 251.829 126.605 258.964C123.163 272.209 113.869 288.811 107.653 298.94C121.92 303.357 137.083 305.74 152.803 305.74C237.021 305.74 305.294 237.467 305.294 153.25C305.294 69.0324 237.021 0.759876 152.803 0.759876Z",
        fill: "#E60023"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_357_4921",
        children: /*#__PURE__*/_jsx("rect", {
          width: "306",
          height: "306",
          fill: "white"
        })
      })
    })]
  }));
};

PinterestLogo.defaultProps = {
  width: "306",
  height: "306",
  viewBox: "0 0 306 306",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var RulerIcon = function RulerIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.25 8.33331H3.125V10.4166H6.25C6.8253 10.4166 7.29167 9.95028 7.29167 9.37498C7.29167 8.79968 6.8253 8.33331 6.25 8.33331ZM6.25 14.5833H3.125V16.6666H6.25C6.8253 16.6666 7.29167 16.2003 7.29167 15.625C7.29167 15.0497 6.8253 14.5833 6.25 14.5833ZM8.33333 21.875V18.75C8.33333 18.1747 8.7997 17.7083 9.375 17.7083C9.9503 17.7083 10.4167 18.1747 10.4167 18.75V21.875H8.33333ZM14.5833 18.75V21.875H16.6667V18.75C16.6667 18.1747 16.2003 17.7083 15.625 17.7083C15.0497 17.7083 14.5833 18.1747 14.5833 18.75Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.74466 5.20833C5.89617 5.20833 5.20833 5.89617 5.20833 6.74466V18.75C5.20833 19.3253 5.6747 19.7917 6.25 19.7917H18.2553C19.1038 19.7917 19.7917 19.1038 19.7917 18.2553C19.7917 17.8479 19.6298 17.4571 19.3417 17.169L7.83101 5.65831C7.54289 5.3702 7.15212 5.20833 6.74466 5.20833ZM3.125 6.74466C3.125 4.74558 4.74558 3.125 6.74466 3.125C7.70465 3.125 8.62533 3.50635 9.30415 4.18517L20.8148 15.6959C21.4936 16.3747 21.875 17.2953 21.875 18.2553C21.875 20.2544 20.2544 21.875 18.2553 21.875H6.25C4.52411 21.875 3.125 20.4759 3.125 18.75V6.74466Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.375 15.1042V11.9761C9.375 11.5121 9.93602 11.2797 10.2641 11.6078L13.3922 14.7359C13.7203 15.064 13.4879 15.625 13.0239 15.625H9.89583C9.60819 15.625 9.375 15.3918 9.375 15.1042Z",
      fill: "#12131A"
    })]
  }));
};

RulerIcon.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var DownChevron = function DownChevron(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7071 0.292986C11.3166 -0.097538 10.6834 -0.097538 10.2929 0.292986L6 4.58588L1.70711 0.292986C1.31658 -0.0975381 0.683417 -0.0975381 0.292893 0.292986C-0.0976314 0.68351 -0.0976314 1.31668 0.292893 1.7072L6 7.41431L11.7071 1.7072C12.0976 1.31668 12.0976 0.68351 11.7071 0.292986Z",
      fill: "#12131A"
    })
  }));
};

DownChevron.defaultProps = {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const PreviewResolutionMenus = _ref => {
  let {
    isCustomizingLayout,
    previewResolution,
    activePreviewGroup,
    previewGroups,
    alwaysVisible = false,
    className,
    isResolutionControlHidden,
    isCustomResolutionControlHidden,
    handlePreviewGroupChange,
    handlePreviewResolutionChange,
    handleCustomResolutionChange
  } = _ref;
  const ref = useRef(null);
  const {
    0: hasFocus,
    1: setHasFocus
  } = useState(alwaysVisible);
  useClickAway(ref, () => {
    if (alwaysVisible) return;
    setHasFocus(false);
  });
  const isCustomLayout = (previewResolution === null || previewResolution === void 0 ? void 0 : previewResolution.id) === 'custom' || isCustomizingLayout;
  const showCustomResolutionControls = isCustomLayout && hasFocus && !isCustomResolutionControlHidden;
  const showPreviewResolutionControls = !isCustomLayout && Boolean(activePreviewGroup);
  const displaySubMenu = !isResolutionControlHidden && (showPreviewResolutionControls || showCustomResolutionControls);
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: clsx(styles.container, {
      [styles['container--focused']]: hasFocus
    }, className),
    children: [/*#__PURE__*/_jsx(ResolutionGroupControl, {
      className: styles.container__primaryMenu,
      isCustomizingLayout: isCustomLayout,
      activePreviewGroup: activePreviewGroup,
      previewGroups: previewGroups,
      handlePreviewGroupChange: handlePreviewGroupChange,
      onFocus: () => setHasFocus(true)
    }), displaySubMenu ? /*#__PURE__*/_jsxs("aside", {
      className: styles.container__subMenu,
      children: [showCustomResolutionControls ? /*#__PURE__*/_jsx(EditLayoutField, {
        width: previewResolution.value[0],
        height: previewResolution.value[1],
        onChange: handleCustomResolutionChange
      }) : /*#__PURE__*/_jsx(_Fragment, {}), showPreviewResolutionControls ? /*#__PURE__*/_jsx(PreviewResolutionControl, {
        activePreviewGroup: activePreviewGroup,
        previewResolution: previewResolution,
        handlePreviewResolutionChange: handlePreviewResolutionChange
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

export default PreviewResolutionMenus;

const ResolutionGroupControl = _ref2 => {
  let {
    className = '',
    isCustomizingLayout,
    activePreviewGroup,
    previewGroups,
    handlePreviewGroupChange,
    onFocus = () => null
  } = _ref2;
  const activePreviewGroupId = isCustomizingLayout ? 'customize' : activePreviewGroup === null || activePreviewGroup === void 0 ? void 0 : activePreviewGroup.id;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.select, className),
    children: [/*#__PURE__*/_jsxs("button", {
      type: "button",
      className: styles.select__button,
      children: [/*#__PURE__*/_jsx(GroupIcon, {
        groupId: activePreviewGroupId ?? 'customize'
      }), /*#__PURE__*/_jsx("span", {
        className: styles.select__button__text,
        children: isCustomizingLayout || !activePreviewGroup ? 'Resize' : activePreviewGroup === null || activePreviewGroup === void 0 ? void 0 : activePreviewGroup.name
      }), /*#__PURE__*/_jsx(DownChevron, {})]
    }), /*#__PURE__*/_jsxs("select", {
      className: styles.select__menu,
      value: activePreviewGroupId,
      onFocus: onFocus,
      onChange: handlePreviewGroupChange,
      children: [previewGroups.map(_ref3 => {
        let {
          id,
          name
        } = _ref3;
        return /*#__PURE__*/_jsx("option", {
          value: id,
          children: name
        }, `group-${id}`);
      }), /*#__PURE__*/_jsx("option", {
        value: "customize",
        children: "Customize"
      })]
    })]
  });
};

const PreviewResolutionControl = _ref4 => {
  var _activePreviewGroup$i;

  let {
    activePreviewGroup,
    previewResolution,
    handlePreviewResolutionChange
  } = _ref4;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.select,
    children: [/*#__PURE__*/_jsxs("button", {
      type: "button",
      className: styles.select__button,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.select__button__text,
        children: previewResolution.label
      }), /*#__PURE__*/_jsx(DownChevron, {})]
    }), /*#__PURE__*/_jsx("select", {
      className: styles.select__menu,
      defaultValue: previewResolution.id,
      onChange: evt => handlePreviewResolutionChange(evt.target.value),
      children: activePreviewGroup === null || activePreviewGroup === void 0 ? void 0 : (_activePreviewGroup$i = activePreviewGroup.items) === null || _activePreviewGroup$i === void 0 ? void 0 : _activePreviewGroup$i.map(_ref5 => {
        let {
          id,
          value,
          label
        } = _ref5;
        return /*#__PURE__*/_jsxs("option", {
          value: id,
          children: [label, " - ", value[0], " x ", value[1]]
        }, id);
      })
    })]
  });
};

const EditLayoutField = _ref6 => {
  let {
    width,
    height,
    onChange
  } = _ref6;

  const handleChange = (evt, isWidth) => {
    const {
      value
    } = evt.target;
    if (isWidth) onChange({
      width: value
    });
    if (!isWidth) onChange({
      height: value
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    className: styles.editLayoutField,
    children: [/*#__PURE__*/_jsx("input", {
      className: styles.editLayoutField__input,
      type: "number",
      onChange: evt => handleChange(evt, true),
      defaultValue: `${width}`,
      min: "1"
    }), /*#__PURE__*/_jsx("span", {
      className: styles.editLayoutField__separator,
      children: "x"
    }), /*#__PURE__*/_jsx("input", {
      className: styles.editLayoutField__input,
      type: "number",
      onChange: evt => handleChange(evt, false),
      defaultValue: `${height}`,
      min: "1"
    })]
  });
};

const GroupIcon = _ref7 => {
  let {
    groupId
  } = _ref7;
  let Icon;
  let classNames = '';

  if (groupId === 'mobile-devices') {
    Icon = MobileIcon;
    classNames = styles['select__button__icon--gray70'];
  } else if (groupId === 'desktop-devices') {
    Icon = LaptopIcon;
    classNames = styles['select__button__icon--gray70'];
  } else if (groupId === 'paper') {
    Icon = PaperIcon;
    classNames = styles['select__button__icon--gray70'];
  } else if (groupId === 'customize') {
    Icon = RulerIcon;
    classNames = styles['select__button__icon--gray70'];
  } else if (groupId === 'facebook') {
    Icon = FacebookLogo;
  } else if (groupId === 'instagram') {
    Icon = InstagramLogo;
  } else if (groupId === 'linkedin') {
    Icon = LinkedinLogo;
  } else if (groupId === 'product-hunt') {
    Icon = ProductHuntLogo;
  } else if (groupId === 'pinterest') {
    Icon = PinterestLogo;
  }

  return Icon ? /*#__PURE__*/_jsx(Icon, {
    className: clsx(styles.select__button__icon, classNames || '')
  }) : /*#__PURE__*/_jsx(_Fragment, {});
};